import { twMerge } from "tailwind-merge";

interface DividerProps {
  readonly className?: string;
}

export function Divider({ className }: DividerProps) {
  return <hr className={twMerge("border-t border-border", className)} />;
}
